import type { Module } from 'vuex'
import type { RootState } from '@/store/modules/types'

export type NavigationState = {
  navigationTitle?: string
  isSecondaryNavigationVisible: boolean
  isSecondaryNavigationEnabled: boolean
  navigationItems?: Array<object>
  isMainNavLogoHovered: boolean
}

export const initialNavigationState = (): NavigationState => ({
  navigationTitle: '', // displayed at the top, beside the X close icon
  isSecondaryNavigationVisible: true, // shows / hides, default to true/visible
  isSecondaryNavigationEnabled: true,
  isMainNavLogoHovered: false,
  navigationItems: [],
})

const secondaryNavigationModule: Module<NavigationState, RootState> = {
  namespaced: true,
  state: initialNavigationState,
  mutations: {

    SET_IS_MAIN_NAV_LOGO_HOVERED(state: NavigationState, payload: boolean) {
      state.isSecondaryNavigationEnabled = payload
    },

    SET_IS_SECONDARY_NAVIGATION_ENABLED(state: NavigationState, payload: boolean) {
      state.isSecondaryNavigationEnabled = payload
    },

    SET_IS_SECONDARY_NAVIGATION_VISIBLE(state: NavigationState, payload: boolean) {
      state.isSecondaryNavigationVisible = payload
    },

    /**
         * Set the title of the secondaryNavigationModule.  This is usually done in the same function that defines the component.
         * @param state - The state of the application module.
         * @param payload - The title of the drawer.
         */
    SET_NAVIGATION_TITLE(state: NavigationState, payload: string) {
      state.navigationTitle = payload
    },

    SET_NAVIGATION_ITEMS(state: NavigationState, payload: []) {
      state.navigationItems = payload
    },

  }, getters: {
    isSecondaryNavigationVisible: (state: NavigationState) => state.isSecondaryNavigationVisible, // show / hide the drawer
    isSecondaryNavigationEnabled: (state: NavigationState) => state.isSecondaryNavigationEnabled, // enables / disables the nav and button
    secondaryNavigationTitle: (state: NavigationState) => state.navigationTitle, // the title of the drawer, displayed at the top
    navigationItems: (state: NavigationState) => state.navigationItems, // the title of the drawer, displayed at the top
    isMainNavLogoHovered: (state: NavigationState) => state.isMainNavLogoHovered, // the title of the drawer, displayed at the top
  },
}

export default secondaryNavigationModule
